import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { styled } from '@mui/material/styles';
import { observer } from 'mobx-react-lite';
import { Paper, Stack, Box, IconButton, Typography, Stepper, Step, StepLabel, StepContent, Divider, CardActionArea, CardMedia, } from '@mui/material';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';
import { Circle as CircleIcon, Remove as RemoveIcon, Check as CheckIcon, Close as CloseIcon, KeyboardArrowDown as KeyboardArrowDownIcon, KeyboardArrowUp as KeyboardArrowUpIcon, } from '@mui/icons-material';
import { navStore, useStore, useTokens, } from '@mcn-platform/models';
import { courseItemStatus } from '../../../course/constants';
import PanelTitle from '../PanelTitle';
import LessonMediaCard from './LessonMediaCard';
import ItemContent from '../../../class/lessonPanel/ItemContent';
import { configureSalesCard, configLandingPage } from '../../../common/portalConfig';
import LessonDialog from './LessonDialog';
import PlaceHolder from '../../../common/PlaceHolder';
const StyledDivider = styled(Divider)(({ theme }) => ({
    borderColor: theme.portal?.site?.lineColor || theme.palette.dividerSecondary,
    borderBottomWidth: 2,
    marginTop: theme.spacing(3.25),
}));
const StyledConnector = styled(StepConnector, {
    shouldForwardProp: (prop) => (!['isProgram', 'progressBarColor'].includes(prop)),
})(({ theme, isProgram, progressBarColor }) => {
    const borderWidth = isProgram ? 5 : 0;
    return ({
        height: 16,
        marginLeft: theme.spacing(2.25),
        [`& .${stepConnectorClasses.line}`]: {
            borderLeftWidth: borderWidth,
            borderLeftStyle: 'solid',
            borderColor: progressBarColor,
        },
    });
});
const StyledStepIconRoot = styled('div')(({ theme, ownerState: { viewStatus, progressBarColor }, }) => ({
    //   backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[700] : '#ccc',
    display: 'flex',
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center',
    width: 40,
    height: 40,
    fontSize: 15,
    color: theme.palette.common.white,
    ...((viewStatus === courseItemStatus.NOT_STARTED) && {
        color: progressBarColor, // override icon color
        backgroundColor: progressBarColor,
    }),
    ...((viewStatus === courseItemStatus.IN_PROGRESS) && {
        backgroundColor: theme.palette.tertiary.main,
    }),
    ...((viewStatus === courseItemStatus.DONE) && {
        backgroundColor: theme.palette.success.main,
    }),
    ...((viewStatus === courseItemStatus.SKIPPED) && {
        backgroundColor: theme.palette.error.main,
    }),
}));
const StyledStepIconContainer = styled('div')(({ progressBarColor }) => ({
    //   backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[700] : '#ccc',
    display: 'flex',
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center',
    width: 5,
    height: 100,
    fontSize: 15,
    marginLeft: 18,
    color: progressBarColor,
    backgroundColor: progressBarColor,
}));
const StyledStepIcon = (props, isRoot, viewStatus, section, isProgram, progressBarColor) => {
    if (!isProgram)
        return null;
    if (section.type === 'container') {
        return (_jsx(StyledStepIconContainer, { progressBarColor: progressBarColor })
        // <Box
        //   sx={{
        //     display: 'flex',
        //     borderRadius: '50%',
        //     justifyContent: 'center',
        //     alignItems: 'center',
        //     width: 5,
        //     height: 100,
        //     fontSize: 15,
        //     marginLeft: 18,
        //     color: progressBarColor, // override icon color
        //     backgroundColor: progressBarColor,
        //   }}
        // />
        );
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { className, icon } = props;
    // console.log('custom icon status ==> ', isRoot, viewStatus);
    // console.log('default icon status => ', icon);
    const icons = {
        NOT_STARTED: _jsx(CircleIcon, {}), // NOT_STARTED
        IN_PROGRESS: _jsx(RemoveIcon, {}), // IN_PROGRESS
        DONE: _jsx(CheckIcon, {}), // DONE green
        SKIPPED: _jsx(CloseIcon, {}), // SKIPPED red
        // IN_PROGRESS for root section
        IN_PROGRESS_ROOT: _jsx(CircleIcon, { sx: { color: (theme) => theme.palette.tertiary.main } }),
    };
    return (_jsx(StyledStepIconRoot, { ownerState: { viewStatus, progressBarColor }, className: className, children: icons[String((isRoot && viewStatus === courseItemStatus.IN_PROGRESS) ? 'IN_PROGRESS_ROOT' : viewStatus)] }));
};
const getSectionName = (section) => {
    if (section.type === 'course' && (section.name === 'New course' || section.name === '')) {
        return section.item.course ? section.item.course.name : section.name;
    }
    return section.name;
};
const SectionLabel = observer(({ isRoot, section, progress, isProgram, expanded, expandSection, currentPortal, progressBarColor, }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const variant = isRoot ? 'h3' : 'h4';
    const sectionLabelWidth = section.type === 'container' ? 5 : 3;
    let viewStatus = 'NOT_STARTED';
    if (section.type === 'quiz' || section.type === 'knowledgeCheck') {
        const quizResults = progress?.quizResults?.[section?.item?.id];
        if (quizResults) {
            if (quizResults.isCompleted) {
                if (quizResults.isPassed) {
                    viewStatus = 'DONE';
                }
                else {
                    viewStatus = 'SKIPPED';
                }
            }
            else if (quizResults.isStarted) {
                viewStatus = 'IN_PROGRESS';
            }
        }
    }
    else if (section.type === 'certification') {
        if (progress?.completedCertifications?.includes(section?.item?.certification)) {
            viewStatus = 'DONE';
        }
    }
    else {
        const sectionProgress = progress?.sectionProgress?.[section?.id];
        if (sectionProgress) {
            if (sectionProgress.isCompleted || sectionProgress.progress > 99) {
                viewStatus = 'DONE';
            }
            else if (sectionProgress.startedDate || sectionProgress.isStarted) {
                viewStatus = 'IN_PROGRESS';
            }
        }
    }
    let sectionTitle = null;
    if (section.type === 'course' && section?.item?.course?.checkAccess()) {
        const { action: cardAction, } = configureSalesCard(currentPortal, section.item.course, undefined, navigate, location, '.');
        sectionTitle = (_jsx(CardActionArea, { onClick: () => {
                if (cardAction) {
                    cardAction();
                }
            }, children: _jsx(CardMedia, { children: _jsx(Typography, { variant: variant, fontWeight: "fontWeightBold", children: getSectionName(section) }) }) }));
    }
    if (!sectionTitle) {
        sectionTitle = (_jsx(Typography, { component: "div", fontWeight: "fontWeightBold", className: "landingpage-section-subheader", children: getSectionName(section) }));
    }
    return (_jsx(StepLabel, { sx: { p: 0, maxHeight: 40 }, StepIconComponent: (props) => (StyledStepIcon(props, isRoot, viewStatus, section, isProgram, progressBarColor)), children: _jsxs(Stack, { sx: { pl: { sm: isProgram ? sectionLabelWidth : 1, xs: 0 } }, direction: "row", justifyContent: "space-between", children: [_jsx(Box, { sx: { marginY: 'auto', pl: 0.875 }, children: _jsx(Typography, { variant: "h4", className: "landingpage-section-subheader", children: sectionTitle }) }), _jsx(Box, { children: section.sections?.length > 0 && (_jsx(IconButton, { onClick: () => expandSection(section), children: expanded.includes(section.id)
                            ? _jsx(KeyboardArrowDownIcon, { fontSize: "large" }) : _jsx(KeyboardArrowUpIcon, { fontSize: "large" }) })) })] }) }));
});
const CourseSectionContent = ({ item, section, currentPortal, action, progressBarColor, }) => (_jsxs(StepContent, { sx: {
        pt: 1.5,
        pl: { sm: 0, xs: 3 },
        marginLeft: 2.25,
        borderLeftWidth: 0,
        borderLeftStyle: 'solid',
        borderColor: progressBarColor,
    }, children: [section.item ? (_jsx(LessonMediaCard, { item: item, portal: currentPortal, section: section, action: action, sectionItem: section.item }, section.item.key)) : (_jsx(Typography, { variant: "body1", className: "description", children: section.description })), _jsx(StyledDivider, {})] }));
/**
 * Lesson Action Rules:
 * 1. If the section is a course or microcast - then this action is not used
 * 2. If the user has access to the program:
 *    1.0 If not started, start the program
 *    1.1 Open the lesson dialog and show the lesson
 * 2. If the user does not have access to the program:
 *    2.1  There is no action available
 */
const getLessonAction = (currentPortal, program, programProgress, setLessonOpen, startProgram) => {
    const hasAccess = currentPortal.type === 'public' || program.checkAccess();
    if (!hasAccess) {
        return null;
    }
    if (!programProgress) {
        return async () => {
            const progress = await startProgram(program.key);
            if (progress) {
                setLessonOpen(true);
            }
            else {
                console.log('Failed to start program');
            }
        };
    }
    return () => setLessonOpen(true);
};
const ProgramSectionContent = ({ program, programProgress, section, progressBarColor, }) => {
    const [lessonOpen, setLessonOpen] = useState(false);
    const [lessonDuration, setLessonDuration] = useState(0);
    const [lastPercentUpdate, setLastPercentUpdate] = useState(0);
    const updateProgressInterval = 30;
    const store = useStore();
    const { currentPortal, trackProgramProgress } = store;
    const startProgram = async (programKey) => {
        try {
            navStore.showBlockInput();
            const newProgress = await store.startProgram(programKey);
            return newProgress;
        }
        finally {
            navStore.clearBlockInput();
        }
    };
    const lessonAction = getLessonAction(currentPortal, program, programProgress, setLessonOpen, startProgram);
    const onEnd = async () => {
        // if its already complete then don't update
        const sectionProgress = programProgress?.sectionProgress[section.id];
        if (sectionProgress?.isCompleted) {
            console.log('section already completed');
            return;
        }
        await trackProgramProgress(program?.key, section.id, 100);
    };
    const onMediaProgress = async (progress) => {
        // if its already complete then don't update
        const sectionProgress = programProgress?.sectionProgress[section.id];
        if (sectionProgress?.isCompleted) {
            console.log('section already completed');
            return;
        }
        const percent = Math.ceil((progress / (lessonDuration || 1)) * 100);
        if (progress > 0
            && ((Math.ceil(progress) % updateProgressInterval === 0) // do an update every 30 seconds
                || Math.ceil(progress) === 1 // do an update after 1st second to mark it as started
            )) {
            await trackProgramProgress(program?.key, section.id, percent);
        }
        else if ((percent >= 99 || (lessonDuration && (lessonDuration - progress) < 5))
            && percent !== lastPercentUpdate) {
            // flip it to done if over 98% or less than 5 seconds remaining
            trackProgramProgress(program?.key, section.id, 100);
            setLastPercentUpdate(percent);
        }
    };
    return (_jsxs(StepContent, { sx: {
            pt: 1.5,
            pl: { sm: 6.5, xs: 3 },
            marginLeft: 2.25,
            borderLeftWidth: 5,
            borderLeftStyle: 'solid',
            borderColor: progressBarColor,
        }, children: [section.item ? (_jsx(LessonMediaCard, { item: program, portal: currentPortal, section: section, action: lessonAction, sectionItem: section.item, isProgram: true }, section.item.key)) : (_jsx(Typography, { variant: "body1", className: "description", children: section.description })), _jsx(StyledDivider, {}), _jsx(LessonDialog, { title: section.name, open: lessonOpen, handleClose: () => setLessonOpen(false), children: _jsx(ItemContent, { section: section, progress: programProgress, showPlayerControls: true, onDuration: setLessonDuration, onProgress: onMediaProgress, onEnd: onEnd, seekPosition: undefined, handleNextPrevious: () => { } }) })] }));
};
const SectionStep = observer(({ section, item, progress, isRoot, expanded, setExpanded, currentPortal, action, // this is the program or course level action (not the section item's action)
progressBarColor, }) => {
    const expandSection = (newSection) => {
        const i = expanded.findIndex((s) => s === newSection.id);
        const newList = [...expanded];
        if (i === -1) {
            setExpanded([...newList, newSection.id]);
        }
        else {
            newList.splice(i, 1);
            setExpanded(newList);
        }
    };
    const isProgram = item.isProgram();
    return (_jsxs(Step, { id: section.id, active: true, children: [_jsx(SectionLabel, { isRoot: isRoot, section: section, progress: progress, isProgram: isProgram, expanded: expanded, expandSection: expandSection, currentPortal: currentPortal, progressBarColor: progressBarColor }), isProgram ? (_jsx(ProgramSectionContent, { program: item, section: section, programProgress: progress, progressBarColor: progressBarColor })) : (_jsx(CourseSectionContent, { item: item, section: section, currentPortal: currentPortal, action: action, progressBarColor: progressBarColor })), expanded.includes(section.id) && section.sections?.map((subSection) => (_jsx(SectionStep, { item: item, section: subSection, progress: progress, isRoot: false, expanded: expanded, setExpanded: setExpanded, currentPortal: currentPortal, action: action, progressBarColor: progressBarColor }, subSection.id)))] }, section.id));
});
const SyllabusContent = ({ sections, item, title, titleTokenKey, settings: { showTitle, showSyllabus }, editData, progressBarColor = SyllabusContent.defaultProps.progressBarColor, }) => {
    // const [itemProgress, setItemProgress] = useState<
    //   IProgramProgress | ICourseProgress | undefined
    // >();
    const store = useStore();
    const { currentPortal, } = store;
    const tokens = useTokens();
    const navigate = useNavigate();
    const location = useLocation();
    const [searchParams] = useSearchParams();
    const [expanded, setExpanded] = React.useState(item.sections.map((section) => (section.id)));
    const progressLink = store.getProgressLink(item.key);
    const { progress } = progressLink;
    useEffect(() => {
        const param = searchParams.get('item');
        if (param) {
            const doc = document.getElementById(param);
            if (doc) {
                doc.scrollIntoView({ block: 'center', behavior: 'smooth' });
            }
        }
    }, [searchParams]);
    if (!item) {
        return editData ? (_jsx(PlaceHolder, { placeHolderName: "Select program to see preview" })) : null;
    }
    console.log('syllabus progress', progress);
    const { action, } = configLandingPage(currentPortal, item, undefined, navigate, location, '.');
    if (!currentPortal || !item) { // || (isProgram && !itemProgress)) {
        return null;
    }
    const visibleSections = sections?.filter((section) => !section?.item?.hidden);
    return (_jsxs(Paper, { elevation: 0, sx: { display: 'flex', flexDirection: 'column' }, id: "SyllabusContent", children: [showTitle && _jsx(PanelTitle, { title: titleTokenKey ? tokens.getToken(titleTokenKey) : title }), showSyllabus && (_jsx(Stepper, { nonLinear: true, orientation: "vertical", connector: (_jsx(StyledConnector, { isProgram: item.isProgram(), progressBarColor: progressBarColor })), children: visibleSections?.map((section) => (_jsx(SectionStep, { item: item, section: section, progress: progress, isRoot: true, currentPortal: currentPortal, expanded: expanded, setExpanded: setExpanded, action: action, progressBarColor: progressBarColor }, section.id))) }))] }));
};
SyllabusContent.getData = async ({ sections, item }) => {
    console.log('Syllabus.getData called', { sections, item });
};
SyllabusContent.defaultProps = {
    // title: 'COURSE OUTLINE',
    titleTokenKey: 'courseOutlineLabel',
    progressBarColor: '#ebebeb',
    settings: {
        showTitle: true,
        showSyllabus: true,
    },
    editData: undefined,
};
SyllabusContent.meta = {
    group: 'hidden',
    name: 'Course Outline',
    description: 'Component displays the course sections and lessons structure',
    props: [
        {
            key: 'course',
            name: 'Course',
            type: 'course', // note this is a special type recognized by the system
            description: 'The course to display information about',
        },
        {
            key: 'settings.showTitle',
            name: 'Show Title',
            type: 'boolean',
            description: 'Show the title on the Syllabus panel',
        },
        {
            key: 'settings.showSyllabus',
            name: 'Show Course Outline Structure',
            type: 'boolean',
            description: 'Show the syllabus structure on the Syllabus panel',
        },
    ],
    defaultConfig: {
        type: 'component',
        component: 'Syllabus',
        props: {
            sections: '@course.sections',
            instructors: '@course.instructors',
            title: 'COURSE OUTLINE',
            settings: {
                showTitle: true,
                showSyllabus: true,
            },
        },
    },
};
export default observer(SyllabusContent);
//# sourceMappingURL=SyllabusContent.js.map